import React from 'react'
import PendingItems from '../PendingItems'

export default function Home () {
  return <PendingItems />
}
